// Automatic Refill
document.querySelector(".productRosabellaAutomaticRefillInput").addEventListener("change", function () {
    document.querySelector("#productRosabella").classList.toggle("automaticRefillActive", this.checked);
    updatePrice();
    updateProductOptionBoxes();
});

// Option Change Listeners
document.querySelectorAll(".productRosabellaProductOptionInput").forEach(function (optionInput) {
    optionInput.addEventListener("change", function () {
        updatePrice();
        updateProductOptionBoxes();
    });
});

document.addEventListener("DOMContentLoaded", function () {
    updatePrice();
    updateProductOptionBoxes();


    /**************
     Try Respire Buttons
     ***************/
    document.querySelectorAll(`.button[href="#"]`).forEach(button => button.addEventListener("click", function (event) {
        event.preventDefault();

        document.querySelector("#productRosabellaContent").scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    }));
});

function normalizeSavingNumber(number) {
    if(number === 9){
        return 10;
    }
    else if(number === 12){
        return 10;
    }
    else if(number === 41){
        return 40;
    }

    return number;
}

function updatePrice() {
    const activeVariant = getActiveVariant();
    const isAutomaticRefill = document.querySelector(".productRosabellaAutomaticRefillInput:checked");

    let realPrice = activeVariant.price;
    let comparePrice = activeVariant.compare_at_price;

    // Hardcoded check for 1 Month Supply
    if (activeVariant.title.includes("1 Pack") && isAutomaticRefill) {
        comparePrice = activeVariant.price;
    }

    // The prices will be based on the selling plan prices if automatic refill is checked and the variant has selling plans
    if (activeVariant.selling_plan_allocations.length > 0) {
        realPrice = isAutomaticRefill ? activeVariant.selling_plan_allocations[0].per_delivery_price : activeVariant.price;
    }

    // Calculate Savings
    let savings = normalizeSavingNumber(Math.round(((comparePrice - realPrice) / comparePrice) * 100));

    // Update savings
    document.querySelector(".productRosabellaPriceSave").textContent = savings > 0 ? `${savings}% OFF` : "";
    document.querySelector(".productRosabellaYouSaveSavings").textContent = savings > 0 ? `${savings}% OFF` : "";

    // Update Price
    document.querySelector(".productRosabellaPrice").classList.toggle("sale", savings > 0);
    document.querySelector(".productRosabellaPriceCompare").textContent = (comparePrice !== null && comparePrice > realPrice) ? price(comparePrice) : "";
    document.querySelector(".productRosabellaPriceReal").textContent = price(realPrice);

    // Update Value
    document.querySelector(".productRosabellaYouSaveValueAmount").textContent = comparePrice ? price(comparePrice) : price(realPrice);
    document.querySelector(".productRosabellaYouSavePriceAmount").textContent = price(realPrice);
}

function updateProductOptionBoxes() {
    // Update each option saving box
    document.querySelectorAll(".productRosabellaProductOptionLabel").forEach(function (option) {
        // Find associated variant from options
        const variant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify([option.querySelector("input").value]);
        });

        const isAutomaticRefill = document.querySelector(".productRosabellaAutomaticRefillInput:checked");

        let realPrice = variant.price;
        let comparePrice = variant.compare_at_price;

        // The prices will be based on the selling plan prices if automatic refill is checked and the variant has selling plans
        if (variant.selling_plan_allocations.length > 0) {
            realPrice = isAutomaticRefill ? variant.selling_plan_allocations[0].per_delivery_price : variant.price;
        }

        // Hardcoded check for 1 Month Supply
        if (variant.title.includes("1 Month") && !variant.compare_at_price && isAutomaticRefill) {
            comparePrice = variant.price;
        }

        // Calculate savings
        let savings = normalizeSavingNumber(Math.round(((comparePrice - realPrice) / comparePrice) * 100));

        // Update Price
        option.querySelector(".productRosabellaProductOptionPricesReal").textContent = price(realPrice);
        option.querySelector(".productRosabellaProductOptionPricesCompare").textContent = (comparePrice !== null && comparePrice > realPrice) ? price(comparePrice) : "";
        option.querySelector(".productRosabellaProductOptionLabelTextNameSavings").textContent = savings > 0 ? `${savings}% OFF` : "";
    });
}

function getActiveVariant() {
    const options = Array.from(document.querySelectorAll(`.productRosabellaProductOptionInput:checked`)).map(input => input.value);
    return product.variants.find((variant) => JSON.stringify(variant.options) === JSON.stringify(options));
}

/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productRosabellaSwiper", {
    slidesPerView: 1,
    breakpoints: {
        800: {
            spaceBetween: 20,
            pagination: false
        }
    },
    navigation: {
        prevEl: '#productRosabellaSwiperPrev',
        nextEl: '#productRosabellaSwiperNext',
    },
    spaceBetween: 40,
});

// thumbnail
document.querySelectorAll(".productRosabellaThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productImages.slideTo(index);
    });
});

/**************
 Product FAQs
 ***************/

document.querySelectorAll('.productRosabellaFaqTop').forEach(el => {
    let parent = el.closest('.productRosabellaFaq');
    el.addEventListener('click', function () {
        this.classList.toggle('active');
        parent.querySelector('.productRosabellaFaqBottom').classList.toggle('active');
    })
})

/**************
 Product ATC
 ***************/

document.querySelector("#productRosabellaATC").addEventListener("click", async function () {
    this.classList.add("loading");

    const activeVariant = getActiveVariant();

    let atcPayload = {
        items: [
            {
                quantity: 1,
                id: activeVariant.id,
            }
        ]
    }

    if (document.querySelector(".productRosabellaAutomaticRefillInput:checked")) {
        atcPayload.items[0].selling_plan = activeVariant.selling_plan_allocations[0].selling_plan_id;

        variantFreeGifts[activeVariant.id]?.forEach((item) => {
            atcPayload.items.push({
                id: item,
                quantity: 1
            })
        })
    }

    await addProduct(atcPayload);

    await openCart();

    this.classList.remove("loading");
});